<template>
	<div class="login">
		<div class="loginPageBox">
			<el-form :model="loginData" :rules="rules" ref="loginData" label-width="80px" class="loginForm">
				<el-form-item label="用户名: " prop="userName">
					<el-input v-model="loginData.userName">
						<i slot="prefix" class="el-input__icon el-icon-user"></i>
					</el-input>
				</el-form-item>
				<el-form-item label="密码: " prop="passWord">
					<el-input v-model="loginData.passWord" show-password>
						<i slot="prefix" class="el-input__icon el-icon-lock"></i>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="login('loginData')">登 录</el-button>
					<el-button type="primary" @click="oidcLogin()">idp登录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
export default {
	data: () => {
		return {
			loginData: {
				userName: '',
				passWord: '',
			},
			rules: {
				userName: [
					{ required: true, message: '请输入用户名', trigger: 'blue'}
				],
				passWord: [
					{ required: true, message: '请输入密码', trigger: 'blue'}
				]
			}
		}
	},
	methods: {
		login: function(loginData) {
			const self = this;
			this.$refs[loginData].validate((valid) => {
				if (valid) {
					self.loginFn();
				}
			});
		},
	
		loginFn: function() {
			const self = this;
			let params = {};
			params.userName = self.loginData.userName;
			params.pwd = self.loginData.passWord;
			self.$axios_api.login(params).then(res => {
				self.$message({
					message: '登录成功',
					type: 'success'
				});
				self.$router.push({
					path: '/app'
				});
			})
		},
		
		oidcLogin: function() {
			this.$router.push({
				path: '/oidc/login'
			})
		}
	}
}
</script>

<style>
	.loginPageBox {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.loginForm{
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
	}
	.login{
		background-color: #B3C0D1;
		height: 100%;
		width: 100%;
	}
</style>
